import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Property } from "./property.model";
/**
 * @class GuestsStatus
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 * @property {string} color
 * @property {string} description
 * @property {string} status
 */
export class GuestsStatus extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }
    
    static get validationModel() {

        return {
            name: {
                label: 'GUEST_STATUS_NAME_IN_ENGLISH',
                commonLabel: 'Guest Status name'
            },
            name_ar: {
                label: 'GUEST_STATUS_NAME_IN_ARABIC',
                commonLabel: 'Guest Status name'
            },
        };
    }
}

AccessorsMutatorsDecorator('id', ...GuestsStatus.translatableAttributesWithLanguageAliases, 'property', 'property_id', 'color', 'description', 'status')(GuestsStatus);


// WEBPACK FOOTER //
// ./src/pms-api/models/guests-status.model.js